module.exports = __webpack_public_path__ + "img/theodora.0e0bf757.jpg";